// src/app/redux/reducers/changeRequestReducer.js

import {
    FETCH_ALL_REQUESTS_REQUEST,
    FETCH_ALL_REQUESTS_SUCCESS,
    FETCH_ALL_REQUESTS_FAIL,
    FETCH_PENDING_FIELDS_REQUEST,
    FETCH_PENDING_FIELDS_SUCCESS,
    VALIDATE_REQUEST_REQUEST,
    VALIDATE_REQUEST_SUCCESS,
    VALIDATE_REQUEST_FAIL,
} from '../actions/changeRequestActions';

const initialState = {
    pendingRequests: [], // pour la compatibilité
    allRequests: [],    // Historique complet
    pendingFields: [],  // Liste des clés de champs bloqués
    loading: false,
    error: null,
};

const changeRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_REQUESTS_REQUEST:
        case FETCH_PENDING_FIELDS_REQUEST:
        case VALIDATE_REQUEST_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_ALL_REQUESTS_SUCCESS:
            return {
                ...state,
                allRequests: action.payload,
                pendingRequests: action.payload.filter(r => r.status === 'pending'),
                loading: false,
            };

        case FETCH_PENDING_FIELDS_SUCCESS:
            return {
                ...state,
                pendingFields: action.payload,
                loading: false,
            };

        case VALIDATE_REQUEST_SUCCESS:
            return {
                ...state,
                // On met à jour l'élément dans la liste au lieu de le supprimer
                allRequests: state.allRequests.map(req => 
                    req.id === action.payload.id ? action.payload : req
                ),
                loading: false,
            };

        case FETCH_ALL_REQUESTS_FAIL:
        case VALIDATE_REQUEST_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default changeRequestReducer;
